module.exports = __webpack_public_path__ + "img/Risk_Rate_v2_244@2x.51350f39.png";